import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetLegalDocumentsResponseBody } from '../LegalDocumentsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseLegalDocumentsQueryValues = {
  appId: string;
};

export const legalDocumentsQueryKeyFactory: IQueryKeyFactory<
  IUseLegalDocumentsQueryValues
> = (values) => values && (['legalDocuments', values.appId] as const);

export const useLegalDocumentsQuery = (
  values?: IUseLegalDocumentsQueryValues,
  options?: UseQueryOptions<IApiGetLegalDocumentsResponseBody, ApiError>,
): UseQueryResult<IApiGetLegalDocumentsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: legalDocumentsQueryKeyFactory(values),
    queryFn: values ? () => api.legalDocuments.getAll(values.appId) : undefined,
    ...options,
  });
};
